import React, {useEffect, useState} from "react";
import UserManagerPage from "./UserManagerPage";
import {IonButton, IonCheckbox, IonInput, IonItem, IonLabel, IonLoading, IonToggle, useIonAlert} from "@ionic/react";
import {useMutation, useQuery} from "@apollo/client";
import {useHistory} from "react-router-dom";
import {USER_GET_ROLES_QUERY, USER_GET_RULES_QUERY, USER_MANAGER_CREATE_USER} from "../../schemas/userManager";

const UserManagerCreateUser: React.FC<any> = () => {

    const history = useHistory();
    const [alert, dismissAlert] = useIonAlert();

    const [name, setName] = useState<string | null | undefined>(undefined);
    const [password, setPassword] = useState<string | null | undefined>(undefined);
    const [email, setEmail] = useState<string | null |  undefined>(undefined);
    const [details, setDetails] = useState<string | null |  undefined>(undefined);
    const [avatar, setAvatar] = useState<string | null |  undefined>(undefined);
    const [status, setStatus] = useState<boolean | null |  undefined>(true);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [rulesList, setRulesList] = useState<number[]>([]);
    const [rolesList, setRolesList] = useState<number[]>([]);

    const [createUserMutation] = useMutation(USER_MANAGER_CREATE_USER);
    const {loading:rolesLoading, error:rolesError, data: rolesData} = useQuery(USER_GET_ROLES_QUERY, {variables: {}});
    const {loading:rulesLoading, error:rulesError, data: rulesData} = useQuery(USER_GET_RULES_QUERY, {variables: {}});

    const createUser = async () => {
        setIsLoading(true);
        // validate data
        let validationErrors : string[] = [];
        if (!name || name.length === 0) {
            validationErrors.push("Name is required.");
        }
        if (!email || email.length === 0) {
            validationErrors.push("Email is required.");
        }
        if (!details || details.length === 0) {
            validationErrors.push("Details is required.");
        }
        if (status !== false && status !== true) {
            validationErrors.push("Status is required.");
        }
        if (!password || password.length < 8) {
            validationErrors.push("Password is required and must be at least 8 characters.");
        }
        if (rolesList.length === 0) {
            validationErrors.push("At least one role is required.");
        }
        if (validationErrors.length > 0) {

            setIsLoading(false);
            alert("Errors found: <ul><li>" + validationErrors.join("</li><li>") + '</li></ul>');
            return;
        }

        const createUserResult = await createUserMutation({
            variables:{
                data:{
                    name,
                    password,
                    email,
                    details,
                    avatar,
                    status,
                    roles: rolesList,
                    rules: rulesList,
                }
            }
        });

        setIsLoading(false);
        if (createUserResult.data.userManagerCreateUser.success) {
            await alert("Successfully created user");

            setName(undefined);
            setPassword(undefined);
            setEmail(undefined);
            setDetails(undefined);
            setAvatar(undefined);
            setStatus(true);
        } else {
            await alert("An error occurred: " + createUserResult.data.userManagerCreateUser.error);
        }
    };

    const updateRoles = async (checked: boolean, roleId: number) => {
        let list = rolesList;
        if (checked) {
            list.push(roleId);
        } else {
            list = list.filter(id => id !== roleId);
        }
        setRolesList(list);
    };

    const updateRules = async (checked: boolean, ruleId: number) => {
        let list = rulesList;
        if (checked) {
            list.push(ruleId);
        } else {
            list = list.filter(id => id !== ruleId);
        }
        setRulesList(list);
    };

    return (
        <UserManagerPage page={'create-user'} >

            <IonLoading isOpen={isLoading}/>

            <div className="userManagerContent">
                <div style={{backgroundColor: '#ffffff', padding: '10px', margin: '0px'}}>

                    <h1 style={{backgroundColor: '#ffffff', padding: '0px', margin: '0px'}}>Create User</h1>



                    <IonInput label="Name" labelPlacement="start" id="txtName" onIonChange={(e) => setName(e.detail.value)} value={name}></IonInput>

                    <IonInput label="Password" labelPlacement="start" id="txtPassword" onIonChange={(e) => setPassword(e.detail.value)} value={password}></IonInput>

                    <IonInput label="Email" labelPlacement="start" id="txtEmail" onIonChange={(e) => setEmail(e.detail.value)} value={email}></IonInput>

                    <IonInput label="Details" labelPlacement="start" id="txtDetails" onIonChange={(e) => setDetails(e.detail.value)} value={details}></IonInput>

                    <IonInput label="Avatar" labelPlacement="start" id="txtAvatar" onIonChange={(e) => setAvatar(e.detail.value)} value={avatar}></IonInput>

                    <IonToggle id="toggleStatus" value="1" checked={!!status} onIonChange={(e) => setStatus(e.detail.checked)}>
                        Active
                    </IonToggle>

                    <div className="panel">
                        <h3>Roles</h3>
                        <p>Select the rules you would like to add to this new role:</p>
                        {rolesData && rolesData.getRoles && rolesData.getRoles.map((role: any) => {
                            return (
                                <div className="checkbox-button" key={"role_" + role.id}>
                                    <div className="checkbox-button-inner">
                                        <IonCheckbox id={'check_role_' + role.id} value={role.id} onIonChange={(e) => updateRoles(e.detail.checked, e.detail.value)} checked={rolesList.includes(role.id)}></IonCheckbox>&nbsp;
                                        <IonLabel onClick={(e) => document.getElementById('check_role_' + role.id)?.click()}>{role.name}</IonLabel>

                                    </div>
                                </div>
                            )
                        })}
                        <div style={{clear: "both"}}></div>
                    </div>

                    <div className="panel">
                        <h3>Rules</h3>
                        <p>Select the rules you would like to add to this new role:<br /><span style={{color: "grey", fontStyle: 'italic'}}>* It is recommended to use roles to manager permissions. Only use roles if you absolutely have to.</span> </p>
                        {rulesData && rulesData.getRules && rulesData.getRules.map((rule: any) => {
                            return (
                                <div className="checkbox-button" key={"rule_" + rule.id}>
                                    <div className="checkbox-button-inner">
                                        <IonCheckbox id={'check_rule_' + rule.id} value={rule.id} onIonChange={(e) => updateRules(e.detail.checked, e.detail.value)} checked={rulesList.includes(rule.id)}></IonCheckbox>&nbsp;
                                        <IonLabel onClick={(e) => document.getElementById('check_rule_' + rule.id)?.click()}>{rule.name}</IonLabel>

                                    </div>
                                </div>
                            )
                        })}
                        <div style={{clear: "both"}}></div>
                    </div>

                    <p style={{textAlign: 'right'}}>
                        <IonButton fill="outline" onClick={() => history.goBack()}>Go Back</IonButton>
                        <IonButton onClick={() => createUser()}>Create User</IonButton>
                    </p>
                </div>
            </div>
        </UserManagerPage>
    );
};


export default UserManagerCreateUser;